module.exports = __webpack_public_path__ + "static/img/case4-bg.ac3a52b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case4-bg.webp
// module id = Cnv1
// module chunks = 0